
import { defineComponent } from "vue"
import { mapGetters } from "vuex"

export default defineComponent({
  layoutSettings: {
    fullWidth: true,
  },

  head () {
    return {
      title: this.getTitle("Медиа"),
    }
  },

  computed: {
    ...mapGetters("app", ["getTitle"]),
    ...mapGetters("user", ["isAdmin"]),
  },
})
